import { useState } from 'react'
import { createPortal } from 'react-dom'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { DashboardCard } from 'styling/GlobalStyles'
import { IWidget } from 'types/dashboard.interface'
import { WidgetHeader, WidgetTitle } from 'pages/HrDashboard/Widgets/widgetParts.styled'
import { WidgetBody } from 'pages/HrDashboard/hrLayout.styled'
import { dashboardAlertCards } from '../dashboardData'
import { AlertsModal } from '../AlertsModal'
import {
  AlertsGrid,
  AlertTile,
  AlertTileTop,
  AlertTileIcon,
  AlertTileCount,
  AlertTileName,
} from './dashboardWidgets.styled'

const warningIcon = (
  <svg viewBox='0 0 24 24'>
    <path d='M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' />
  </svg>
)
const checkIcon = (
  <svg viewBox='0 0 24 24'>
    <path d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' />
  </svg>
)

export const AlertsWidget = ({ modalOpen }: IWidget) => {
  const { alerts } = useSelector((state: RootState) => state.dashboard)
  const [alertsModal, setAlertsModal] = useState({ modalOpen: false, alertId: null, total: null })

  const items = dashboardAlertCards.map((c) => ({
    ...c,
    count: alerts && alerts[c.prop] ? alerts[c.prop] : 0,
  }))
  const sorted = [...items].sort((a, b) => b.count - a.count)

  return (
    <DashboardCard width='1fr' style={{ height: '100%', minHeight: 0, cursor: modalOpen ? 'grab' : 'default' }}>
      <WidgetHeader>
        <WidgetTitle>Alerts</WidgetTitle>
      </WidgetHeader>
      <WidgetBody>
        <AlertsGrid>
          {sorted.map((c) => {
            const active = c.count > 0
            return (
              <AlertTile
                key={c.name}
                $active={active}
                onClick={() =>
                  !modalOpen && setAlertsModal({ modalOpen: true, alertId: c.name, total: c.count })
                }
              >
                <AlertTileTop>
                  <AlertTileIcon $active={active}>{active ? warningIcon : checkIcon}</AlertTileIcon>
                  <AlertTileCount $active={active}>{c.count}</AlertTileCount>
                </AlertTileTop>
                <AlertTileName>{c.name}</AlertTileName>
              </AlertTile>
            )
          })}
        </AlertsGrid>
      </WidgetBody>
      {alertsModal.modalOpen &&
        createPortal(<AlertsModal modal={alertsModal} setModal={setAlertsModal} />, document.body)}
    </DashboardCard>
  )
}
